import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import { UserType } from '../../graphql/generated/graphql';
import topicPolicyCheck, {
  getTopicPolicyRequirement,
  MinimalRoleLevel,
  TopicPolicyAction,
  UserRole,
} from '../../topic/topicPolicyCheck';

const TOPIC_FRAGMENT = gql(`
  fragment getRemoveTopicDisabledMessage_topic on Topic {
    id
    ...topicPolicyCheck_topic
  }
`);

const POST_FRAGMENT = gql(`
  fragment getRemoveTopicDisabledMessage_post on Post {
    id
    publishedAt
    topics {
      id
    }
  }
`);

const REMOVE_DISABLED_MESSAGE: Record<MinimalRoleLevel, string | undefined> = {
  [MinimalRoleLevel.None]: undefined,
  [MinimalRoleLevel.Member]:
    'You must be\na topic member\nto remove this topic.',
  [MinimalRoleLevel.Owner]: 'You must be\na topic owner\nto remove this topic.',
  [MinimalRoleLevel.Never]: 'You cannot remove this topic.',
};

export default function getRemoveTopicDisabledMessage(
  topic: DocumentType<typeof TOPIC_FRAGMENT>,
  user: Parameters<typeof topicPolicyCheck>[2],
  post: DocumentType<typeof POST_FRAGMENT>,
) {
  const requiredLevel =
    !topicPolicyCheck(TopicPolicyAction.EditPost, topic, user) &&
    getTopicPolicyRequirement(TopicPolicyAction.EditPost, topic, user);

  if (requiredLevel) {
    return REMOVE_DISABLED_MESSAGE[requiredLevel];
  }

  const isGuest =
    typeof user === 'string'
      ? user === UserRole.Guest
      : user.type === UserType.Guest;

  if (post.publishedAt && isGuest && post.topics.length === 1) {
    return "Guests cannot\nremove a post's\nlast topic";
  }

  return undefined;
}
